import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { RichTextEditorComponent } from 'src/app/shared/components/rich-text-editor/rich-text-editor.component';
import { OrderModule } from 'ngx-order-pipe';

import { VBuilderAdminRoutingModule } from './v-builder-admin-routing.module';
import { VBuilderCategoryListComponent } from './v-builder-category-list/v-builder-category-list.component';
import { VBuilderCategoryDetailComponent } from './v-builder-category-detail/v-builder-category-detail.component';
import { VBuilderCategoryModalComponent } from './v-builder-category-list/v-builder-category-modal/v-builder-category-modal.component';
import { VBuilderCategoryTemplateModalComponent } from './v-builder-category-detail/v-builder-category-template-modal/v-builder-category-template-modal.component';
import { VBuilderPlaybookModalComponent } from './v-builder-category-detail/v-builder-playbook-modal/v-builder-playbook-modal.component';
import { LoadSecureAssetsModule } from '../shared/modules/load-secure-assets/load-secure-assets';
@NgModule({
    declarations: [
        VBuilderCategoryListComponent,
        VBuilderCategoryDetailComponent,
        VBuilderCategoryModalComponent,
        VBuilderCategoryTemplateModalComponent,
        VBuilderPlaybookModalComponent
    ],
    imports: [
        CommonModule,
        VBuilderAdminRoutingModule,
        DragDropModule,
        FormsModule,
        RichTextEditorComponent,
        OrderModule,
        LoadSecureAssetsModule
    ]
})
export class VBuilderAdminModule { }
